import BaseModal from "../BaseModal";
import {Modal} from "react-bootstrap";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {actionChangeStatusShowModalMyFoodPacks} from "../../../../../redux/actions/modals/modalMyFoodPacks.actions";
import LoaderModals from "../../loaders/LoaderModals";
import CardItemModalMyFoodPacks from "../../card/CardItemModalMyFoodPacks";

const ModalMyFoodPacks = () => {

    const dispatch = useDispatch();
    const {status_show_modal, food_packs, loader_modal} = useSelector(state => state.modalMyFoodPacks);

    const handleClose = () => {
        dispatch(actionChangeStatusShowModalMyFoodPacks(false));
    }

    // useEffect(() => {
    //     if (status_show_modal) {
    //         dispatch({type: 'FETCH_MY_DISCOUNTS', payload: {token}});
    //     }
    //     // eslint-disable-next-line
    // }, [status_show_modal]);



    return (
        <>
            <BaseModal title={'پکیج های غذای من'}
                       show={status_show_modal}
                       dialogClassName={''}
                       handleClose={handleClose}>
                {!loader_modal ? <Modal.Body>
                    <div style={{padding: '0 20px'}}>
                        {food_packs !== undefined ? food_packs.map((food_pack, index) => {
                            return (
                                <CardItemModalMyFoodPacks
                                    key={index}
                                    data={{
                                        food_pack: {
                                            name: food_pack.title,
                                            image: food_pack.image,
                                            id: food_pack.id,
                                            first_desc: food_pack.first_desc, 
                                            second_desc: food_pack.second_desc, 
                                        }
                                    }}
                                    />
                            );
                        }) : ''}
                    </div>
                </Modal.Body>
                : <LoaderModals/>}
            </BaseModal>
        </>
    )
}

export default ModalMyFoodPacks;